<template>
  <div class="manageSigninVue">
    <div class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
                <div class="row">
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-super-signin-area">

                            <div class="head">
                                <h3 class="o-super-title">Header Configuration:</h3>
                            </div>

                            <div class="body">
                                <div class="scrollbar-style o-signin-scroll o-signin-box">

                                    <div class="o-custom-table-container c-common-box-shadow c-radius3 signin-list-table-align" v-for="(sign,key) in header_settings">
                                        <div class="o-calls-table c-common-gradient o-posiotion-relative">
                                            <div class="calls-table-row phonesheet-table-row">
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="calls-table-cell-inner-table">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Row #:</span>
                                                                <div>{{key+1}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Row Text:</span>
                                                            <div><input type="text" class="form-control" v-model="sign.name"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Data:</span>
                                                            <div>
                                                                <div class="o-custom-dropdown">
                                                                    <select class="form-control" v-model="sign.value">

                                                                        <option value="empty">Empty row</option>
                                                                        <option value="title">Event Name</option>
                                                                        <option value="job_number">Job number</option>
                                                                        <option value="employer_id">Employer</option>
                                                                        <option value="start">Dates</option>
                                                                        <option value="venue_id">Location</option>
                                                                        <option value="employer_contact">Employer contact</option>
                                                                        <option value="employee_id">Steward</option>
                                                                        <option value="payroll_id">Payroll</option>
                                                                        <option value="comment">Comments</option>
                                                                        <option value="employer_request">Employer Request</option>
                                                                    </select>
                                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="o-signin-expand-icon">
                                                <a href="javascript: void(0)" @click="addOrDeleteHeader(key)"><i aria-hidden="true" :class="{'fa':true, 'fa-plus-circle':(key == (header_settings.length - 1)), 'fa-minus-circle':(key != (header_settings.length - 1))}"></i></a>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="o-custom-table-container c-radius3 signin-list-table-align">

                                    <ul class="o-signin-sheet-check">
                                        <li>
                                            <div class="checkbox o-custom-radio">
                                                <label>
                                                        Display logo in upper left corner
                                                        <input type="checkbox" v-model="display_logo_header">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="checkbox o-custom-radio">
                                                <label>
                                                        Auto page break on new day?
                                                        <input type="checkbox" v-model="page_breakdown">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                            </div>
                                        </li>


                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /single grid -->
                    <!-- single grid -->
                    <div class="col-sm-6 col-md-6">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-super-signin-area">

                            <div class="head">
                                <h3 class="o-super-title">Call Data Configuration:</h3>
                            </div>

                            <div class="body">
                                <div class="scrollbar-style o-signin-scroll o-signin-box" > 
                                    <!-- {{ call_settings}} -->

                                    <div class="o-custom-table-container c-common-box-shadow c-radius3 signin-list-table-align" v-for="(call,key) in call_settings" :key="key">
                                        <div class="o-calls-table c-common-gradient o-posiotion-relative">
                                            <div class="calls-table-row phonesheet-table-row">
                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="calls-table-cell-inner-table">
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Row #:</span>
                                                                <div>{{key+1}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="calls-table-cell">
                                                    <div class="table-td-border-right">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Column Text:</span>
                                                            <div><input type="text" class="form-control" v-model="call.name"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="calls-table-cell">
                                                    <div class="">
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Data:</span>
                                                            <div>
                                                                <div class="o-custom-dropdown">
                                                                    <select class="form-control" v-model="call.value">
                                                                        <option value="empty">Empty Column</option>
                                                                        <option value="seniority">Seniority</option>
                                                                        <option value="total_shifts">Shift Count</option>
                                                                        <option value="skill_id">Priority, Position</option>
                                                                        <option value="employee_fl">First,Last</option>
                                                                        <option value="employee_lf">Last, First</option>
                                                                        <option value="employee_phone">Phone</option>
                                                                        <option value="start">Time in</option>
                                                                        <option value="end">Time out</option>
                                                                        <option value="confirmed">Confirmed By</option>
                                                                        <option value="underline">Underline</option>
                                                                        <option value="status_id">Status</option>
                                                                        <option value="custom_field_1">Custom Field 1</option>
                                                                        <option value="custom_field_2">Custom Field 2</option>
                                                                    </select>
                                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="o-signin-expand-icon">
                                                <a href="javascript: void(0)" @click="addOrDeleteCallSettings(key)"><i aria-hidden="true" :class="{'fa':true, 'fa-minus-circle':(key != call_settings.length -1),'fa-plus-circle':(key == call_settings.length -1)}"></i></a>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="o-custom-table-container c-radius3 signin-list-table-align">
                                    <div class="col-sm-12">
                                        <h3 class="o-super-title">Sort by:</h3>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="form-group ">
                                            <label class="common-label-text o-super-label">Primary:</label>
                                            <div class="o-custom-dropdown">
                                                <select class="form-control" v-model="sort_call_configuration.primary">
                                                    <option v-for="call in call_settings" :value="call.value" v-if="(call.value!='underline' && call.value!='empty' && call.value!='custom')">{{call.name}}</option>
                                                    <!-- <option value="skill_id">Priority, Position</option>
                                                    <option value="employee_fl">First,Last</option>
                                                    <option value="employee_lf">Last, First</option>
                                                    <option value="start">Time in</option>
                                                    <option value="seniority">Seniority</option> -->
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group ">
                                            <label class="common-label-text o-super-label">Secondary:</label>
                                            <div class="o-custom-dropdown">
                                                <select class="form-control" v-model="sort_call_configuration.secondary">
                                                    <option v-for="call in call_settings" :value="call.value" v-if="(call.value!='underline' && call.value!='empty' && call.value!='custom')">{{call.name}}</option>
                                                    <!-- <option value="skill_id">Priority, Position</option>
                                                    <option value="employee_fl">First,Last</option>
                                                    <option value="employee_lf">Last, First</option>
                                                    <option value="start">Time in</option>
                                                    <option value="seniority">Seniority</option> -->
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group ">
                                            <label class="common-label-text o-super-label">Ternary:</label>
                                            <div class="o-custom-dropdown">
                                                <select class="form-control" v-model="sort_call_configuration.ternary">
                                                    <option v-for="call in call_settings" :value="call.value" v-if="(call.value!='underline' && call.value!='empty' && call.value!='custom')">{{call.name}}</option>
                                                    <!-- <option value="skill_id">Priority, Position</option>
                                                    <option value="employee_fl">First,Last</option>
                                                    <option value="employee_lf">Last, First</option>
                                                    <option value="start">Time in</option>
                                                    <option value="seniority">Seniority</option> -->
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- /single grid -->
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-left">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="backToList()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveConfiguration()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId'

            })
        },
        data() {
            return {
                header_settings: [],
                call_settings: [],
                display_logo_header: 1,
                page_breakdown: 1,
                sort_call_configuration:{
                    primary:'',
                    secondary:'',
                    ternary:'',
                }

            }
        },
        methods: {
            addOrDeleteHeader(key) {
                if (key == this.header_settings.length - 1) {
                    this.header_settings.push({
                        'name': "",
                        'value': 'empty'
                    });
                } else {
                    this.$confirm('This will permanently delete this item. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.header_settings.splice(key, 1);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        });
                    });
                }
            },
            addOrDeleteCallSettings(key) {
                if (key == this.call_settings.length - 1) {
                    this.call_settings.push({
                        'name': "",
                        'value': 'empty'
                    });
                } else {
                    this.$confirm('This will permanently delete this item. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.call_settings.splice(key, 1);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        });
                    });
                }
            },
            saveConfiguration() {
                var data = {
                    'header_settings': JSON.stringify(this.header_settings),
                    'call_data_settings': JSON.stringify(this.call_settings),
                    'display_logo_header': this.display_logo_header,
                    'page_breakdown': this.page_breakdown,
                    'sort_call_configuration': JSON.stringify(this.sort_call_configuration)
                };
                service.post('client/' + this.selectedClientId + "/signInSheetSettings", data, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.selectedClientId
                    })
                    .then((client) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Client Sign In Sheet Saved Successfully.',
                            type: 'success'
                        });

                    }).catch((err) => {
                        console.log(err);
                    });
            },
            backToList() {
                this.$router.push({
                    'path': '/clientList'
                });
            }


        },
        async created() {
            await service.get('client/' + this.selectedClientId, {
                    'Authorization': this.userToken
                })
                .then((client) => {
                    // console.log(client.data.result.sort_call_configuration);
                    this.header_settings = client.data.result.settings['sign-in-sheet'];

                    this.display_logo_header = client.data.result.display_logo_header;
                    this.page_breakdown = client.data.result.page_breakdown;
                        this.sort_call_configuration = client.data.result.sort_call_configuration != '' ? JSON.parse(client.data.result.sort_call_configuration): client.data.result.sort_call_configuration;
                    //console.log(this.header_settings[this.header_settings.length - 1].name.length);
                    if(!this.header_settings || this.header_settings.length == 0)
                    {
                         this.header_settings.push({
                            'name': "",
                            'value': 'empty'
                        });
                    }
                    // else
                    // {
                    //      if (this.header_settings[this.header_settings.length - 1].name.length != 0)
                    //     this.header_settings.push({
                    //         'name': "",
                    //         'value': 'empty'
                    //     });
                    // }
                    this.call_settings = client.data.result.settings['call-data-config'];
                    if(!this.call_settings || this.call_settings.length == 0)
                     {
                         this.call_settings.push({
                            'name': "",
                            'value': 'empty'
                        });
                     }
                     // else
                     // {
                     //     if (this.call_settings[this.call_settings.length - 1] == 0 || this.call_settings[this.call_settings.length - 1].name.length != 0)
                     //    this.call_settings.push({
                     //        'name': "",
                     //        'value': 'empty'
                     //    });
                     // }
                   


                }).catch((err) => {
                    console.log(err);
                });
        }
    }

</script>

<style scoped>

</style>
